import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import useInitExpDataList from "hooks/expense/useInitExpDataList";
import useInitGrReviewDataList from "hooks/goodReceive/useInitGrReviewDataList";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getAllGroupOfSupplier } from "../../redux/handlers/logic/getAllGroupOfSupplier.handler";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { isValidArray, mapMstToOptions } from "utils/HelperFunction";
import { addProductRow, docLimit, getDocTableRowPesInit, mappingOptionNewItemPesCol, mapRowToProductRow, mergeSelectionsInOrder } from "utils/HelperPesFunction";
import usePesProductDataInit from "./usePesProductDataInit";
import { getAllMstNewItemPesCol } from "../../redux/slices/master/getAllMstNewItemPesCol.slice";
import usePesModalInit from "./usePesModalInit";
import usePesForm from "./usePesForm";
import { use } from "react";
export default function useInitPes() {
    var dispatch = useAppDispatch();
    var pesProductDataInitState = usePesProductDataInit();
    var _useState = _sliced_to_array(useState(1), 2), tab = _useState[0], setTab = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), tagselected = _useState1[0], setTagSelected = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), attachments = _useState2[0], setAttachments = _useState2[1];
    var _useState3 = _sliced_to_array(useState("grReviewListState"), 2), docSelected = _useState3[0], setDocSelected = _useState3[1];
    var _useState4 = _sliced_to_array(useState([
        {
            value: "grReviewListState",
            label: "Gr Review",
            keySelected: "grReviewListState",
            stateName: "grReviewListState"
        },
        {
            value: "expListState",
            label: "ใบค่าใช้จ่าย",
            keySelected: "expListState",
            stateName: "expListState"
        }
    ]), 2), docOptions = _useState4[0], setDocOptions = _useState4[1];
    var initDocSelected = {
        grReviewListState: [],
        expListState: []
    };
    var _useState5 = _sliced_to_array(useState(initDocSelected), 2), docSeletecteds = _useState5[0], setDocSeletecteds = _useState5[1];
    var totalSelectedCount = useMemo(function() {
        return Object.values(docSeletecteds).reduce(function(sum, arr) {
            return sum + arr.length;
        }, 0);
    }, [
        docSeletecteds
    ]);
    var _useState6 = _sliced_to_array(useState([]), 2), productRow = _useState6[0], setProductRow = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), sumproductPrice = _useState7[0], setSumproductPrice = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), sumproductNoVat = _useState8[0], setSumproductNoVat = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), sumproductZeroVat = _useState9[0], setSumproductZeroVat = _useState9[1];
    var _useState10 = _sliced_to_array(useState(0), 2), sumproductSevenVat = _useState10[0], setSumproductSevenVat = _useState10[1];
    var _useState11 = _sliced_to_array(useState(0), 2), sumproductBeforeVat = _useState11[0], setSumproductBeforeVat = _useState11[1];
    var _useState12 = _sliced_to_array(useState(0), 2), sumproductOrdered = _useState12[0], setSumproductOrdered = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), updateDocIds = _useState13[0], setUpdateDocIds = _useState13[1];
    var _useState14 = _sliced_to_array(useState({
        columnsort: [
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            }
        ],
        type: "select"
    }), 2), columnsort = _useState14[0], setColumnsort = _useState14[1];
    var _useState15 = _sliced_to_array(useState({
        onlyReceiveProduct: {
            isActive: false,
            name: "แสดงเฉพาะสินค้าส่งแล้ว"
        }
    }), 2), filterDisplay = _useState15[0], setFilterDisplay = _useState15[1];
    var handleRowSelectOverridePesModal = function(param) {
        var _param_ids = param.ids, ids = _param_ids === void 0 ? [] : _param_ids, keySelected = param.keySelected;
        var newIds = Array.from(new Set(ids)); // unique
        setDocSeletecteds(function(prev) {
            var updated = _object_spread_props(_object_spread({}, prev), _define_property({}, keySelected, newIds));
            return updated;
        });
    };
    var handleConfirmSelect = function(context) {
        var docKeySelectedMap = docOptions.map(function(opt) {
            return opt.keySelected;
        });
        var docStateNameMap = docOptions.map(function(opt) {
            return opt.stateName;
        });
        var combinedIds = mergeSelectionsInOrder(docSeletecteds, docKeySelectedMap);
        // map ID → row → productRow
        var combinedRows = combinedIds.map(function(id) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // หาให้ครบทุก data source
                for(var _iterator = docStateNameMap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    var _context_key;
                    var source = ((_context_key = context[key]) === null || _context_key === void 0 ? void 0 : _context_key.data) || [];
                    var found = source.find(function(row) {
                        return row.id === id;
                    });
                    if (found) return _object_spread_props(_object_spread({}, found), {
                        __keySelected: key
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return null;
        }).filter(Boolean);
        var newRows = combinedRows.map(mapRowToProductRow);
        setDocSeletecteds(initDocSelected);
        setProductRow(function(prev) {
            var existing = prev.filter(function(v) {
                return v.docNumber;
            }); // เก็บเฉพาะ row ที่มี docNumber
            var merged = _to_consumable_array(existing).concat(_to_consumable_array(newRows));
            // ลบซ้ำตาม docNumber
            var uniqueByDocNumber = merged.filter(function(row, index, self) {
                return index === self.findIndex(function(r) {
                    return r.docNumber === row.docNumber;
                });
            });
            // คำนวณจำนวนแถวว่างที่ต้องเติม
            var numLeft = docLimit - uniqueByDocNumber.length;
            var addEmptyProductList = addProductRow(numLeft);
            return _to_consumable_array(uniqueByDocNumber).concat(_to_consumable_array(addEmptyProductList));
        });
        pesProductDataInitState.setModal(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                open: false
            });
        });
    };
    // Reducers
    var reducers = {
        groupOfSupplier: useAppSelector(function(state) {
            return state.getAllGroupOfSupplierReducer;
        }),
        pesItemCol: useAppSelector(function(state) {
            return state.getAllMstNewItemPesColReducer;
        })
    };
    var isInitPesLoading = useMemo(function() {
        return reducers.pesItemCol.isFetching || reducers.groupOfSupplier.isFetching;
    }, [
        reducers.pesItemCol.isFetching,
        reducers.groupOfSupplier.isFetching
    ]);
    var options = useMemo(function() {
        var _reducers_groupOfSupplier_data, _reducers_pesItemCol_data, _reducers_groupOfSupplier_data1, _reducers_pesItemCol_data1;
        var optionsInit = {
            pesItemCol: [],
            groupOfSupplier: []
        };
        var isReady = isValidArray((_reducers_groupOfSupplier_data = reducers.groupOfSupplier.data) === null || _reducers_groupOfSupplier_data === void 0 ? void 0 : _reducers_groupOfSupplier_data.data) && isValidArray((_reducers_pesItemCol_data = reducers.pesItemCol.data) === null || _reducers_pesItemCol_data === void 0 ? void 0 : _reducers_pesItemCol_data.data);
        if (!isReady) return optionsInit;
        return {
            groupOfSupplier: mapMstToOptions(((_reducers_groupOfSupplier_data1 = reducers.groupOfSupplier.data) === null || _reducers_groupOfSupplier_data1 === void 0 ? void 0 : _reducers_groupOfSupplier_data1.data) || []),
            pesItemCol: mappingOptionNewItemPesCol(((_reducers_pesItemCol_data1 = reducers.pesItemCol.data) === null || _reducers_pesItemCol_data1 === void 0 ? void 0 : _reducers_pesItemCol_data1.data) || [])
        };
    }, [
        reducers.groupOfSupplier.data,
        reducers.pesItemCol.data
    ]);
    var loadAllMsts = useCallback(function() {
        dispatch(getAllGroupOfSupplier());
        dispatch(getAllMstNewItemPesCol());
    }, []);
    var grReviewListState = useInitGrReviewDataList({
        initStatus: 3
    });
    var expListState = useInitExpDataList({
        initStatus: 2
    });
    var pesModalInitState = usePesModalInit();
    var setModalConfirmCancel = pesModalInitState.setModalConfirmCancel, setModalSuccess = pesModalInitState.setModalSuccess, modalNotApprove = pesModalInitState.modalNotApprove, setModalNotApprove = pesModalInitState.setModalNotApprove;
    var pesFormState = usePesForm({
        setModalSuccess: setModalSuccess,
        setModalNotApprove: setModalNotApprove,
        setModalConfirmCancel: setModalConfirmCancel,
        setTab: setTab,
        setDocSeletecteds: setDocSeletecteds,
        setProductRow: setProductRow,
        columnsort: columnsort,
        setColumnsort: setColumnsort,
        attachments: attachments,
        setAttachments: setAttachments,
        setTagSelected: setTagSelected,
        setUpdateDocIds: setUpdateDocIds,
        modalNotApprove: modalNotApprove
    });
    useEffect(function() {
        loadAllMsts();
    }, []);
    return {
        docLimit: docLimit,
        pesProductDataInitState: pesProductDataInitState,
        grReviewListState: grReviewListState,
        expListState: expListState,
        pesModalInitState: pesModalInitState,
        pesFormState: pesFormState,
        tab: tab,
        setTab: setTab,
        tagselected: tagselected,
        setTagSelected: setTagSelected,
        attachments: attachments,
        setAttachments: setAttachments,
        isInitPesLoading: isInitPesLoading,
        options: options,
        docSelected: docSelected,
        setDocSelected: setDocSelected,
        docSeletecteds: docSeletecteds,
        setDocSeletecteds: setDocSeletecteds,
        handleRowSelectOverridePesModal: handleRowSelectOverridePesModal,
        handleConfirmSelect: handleConfirmSelect,
        docOptions: docOptions,
        setDocOptions: setDocOptions,
        totalSelectedCount: totalSelectedCount,
        productRow: productRow,
        setProductRow: setProductRow,
        sumproductPrice: sumproductPrice,
        setSumproductPrice: setSumproductPrice,
        sumproductNoVat: sumproductNoVat,
        setSumproductNoVat: setSumproductNoVat,
        sumproductZeroVat: sumproductZeroVat,
        setSumproductZeroVat: setSumproductZeroVat,
        sumproductSevenVat: sumproductSevenVat,
        setSumproductSevenVat: setSumproductSevenVat,
        sumproductBeforeVat: sumproductBeforeVat,
        setSumproductBeforeVat: setSumproductBeforeVat,
        sumproductOrdered: sumproductOrdered,
        setSumproductOrdered: setSumproductOrdered,
        updateDocIds: updateDocIds,
        setUpdateDocIds: setUpdateDocIds,
        columnsort: columnsort,
        setColumnsort: setColumnsort,
        filterDisplay: filterDisplay,
        setFilterDisplay: setFilterDisplay
    };
}
